import React from "react"
import { connect } from "react-redux"
import { Map } from "immutable"

import {
    addFeedUpdateModel,
    addFeedUpdateImage
} from "../../../actions/add-feed-actions"

import EditFeedItemDetails from "../knowledge-item/edit/EditFeedItemDetails"
import ViewFeedItemDetails from "../knowledge-item/view/ViewFeedItemDetails"

const AddFeedItemDetails = props =>
    props.isEditMode ? (
        <EditFeedItemDetails {...props} />
    ) : (
        <ViewFeedItemDetails {...props} />
    )

const mapStateToProps = ({ presentation }) => ({
    model: presentation.addFeed.workingModel || Map(),
    fulltext: presentation.addFeed.fulltext,
    isEditMode: presentation.addFeed.isEditMode
})

const mapDispatchToProps = dispatch => ({
    onEventChange: ({ target }) =>
        dispatch(addFeedUpdateModel(target.name, target.value)),
    onValueChange: name => value => dispatch(addFeedUpdateModel(name, value)),
    onImageChange: file => dispatch(addFeedUpdateImage(file))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddFeedItemDetails)
